<ng-container [formGroup]="form">
  <nz-form-item>
    <nz-form-label [nzRequired]="isRequired">
      <p class="form-desc">
        What are the common antecedents or triggers for this behavior? Select
        all that apply.
      </p>
    </nz-form-label>
    <div class="checkbox-wrapper">
      <span
        *ngFor="let antecedent of behaviourAntecedentList; trackBy: trackById"
        nz-checkbox
        [nzChecked]="
          form.get('caseBehaviorAntecedentIds')?.value?.includes(antecedent.id)
        "
        (nzCheckedChange)="
          onCheckboxChange('caseBehaviorAntecedentIds', $event, antecedent.id);
          onAntecedentChange($event, antecedent)
        "
        [nzValue]="antecedent.id">
        {{ antecedent.name }}
      </span>
    </div>
    <div
      class="ant-form-item-explain-error mt-3"
      *ngIf="form.get('caseBehaviorAntecedentIds')?.hasError('required')">
      Please select at least 1 behavior antecedent.
    </div>
  </nz-form-item>
  <ng-container formArrayName="caseBehaviorAntecedentDescription">
    <nz-divider *ngIf="antecedentDescriptionControls.length > 0" />
    <ng-container
      *ngFor="
        let ctrl of antecedentDescriptionControls;
        let i = index;
        trackBy: trackByIndex
      "
      [formGroup]="ctrl">
      <nz-form-item>
        <nz-form-label
          [nzFor]="'antecedent-description-' + i"
          [nzRequired]="true">
          {{ getBehaviorAntecedentTitle(ctrl.value.behaviorAntecedentId) }}
        </nz-form-label>
        <nz-form-control>
          <textarea
            [id]="'antecedent-description-' + i"
            name="description"
            [attr.aria-label]="
              getBehaviorAntecedentTitle(ctrl.value.behaviorAntecedentId)
            "
            formControlName="description"
            rows="4"
            nz-input
            placeholder="Enter description"
            (input)="
              onControlInputChange($event, ctrl.get('description'))
            "></textarea>
          <div class="mt-3 remaining-text">
            {{ ctrl.value.description.length }} of 4000 characters used
          </div>
          <div
            class="ant-form-item-explain-error mt-3"
            *ngIf="ctrl.get('description')?.errors?.['required']">
            Please enter your description.
          </div>
        </nz-form-control>
      </nz-form-item>
    </ng-container>
  </ng-container>
</ng-container>
